var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7857 1.42857H17.6429V0H16.2143V1.42857H4.78571V0H3.35714V1.42857H1.21429L0.5 2.14286V19.2857L1.21429 20H19.7857L20.5 19.2857V2.14286L19.7857 1.42857ZM19.0714 18.5714H1.92857V5.71429H19.0714V18.5714ZM19.0714 4.28571H1.92857V2.85714H19.0714V4.28571ZM4.78571 10H3.35714V11.4286H4.78571V10ZM3.35714 12.8571H4.78571V14.2857H3.35714V12.8571ZM4.78571 15.7143H3.35714V17.1429H4.78571V15.7143ZM7.64286 10H9.07143V11.4286H7.64286V10ZM9.07143 12.8571H7.64286V14.2857H9.07143V12.8571ZM7.64286 15.7143H9.07143V17.1429H7.64286V15.7143ZM9.07143 7.14286H7.64286V8.57143H9.07143V7.14286ZM11.9286 10H13.3571V11.4286H11.9286V10ZM13.3571 12.8571H11.9286V14.2857H13.3571V12.8571ZM11.9286 15.7143H13.3571V17.1429H11.9286V15.7143ZM13.3571 7.14286H11.9286V8.57143H13.3571V7.14286ZM16.2143 10H17.6429V11.4286H16.2143V10ZM17.6429 12.8571H16.2143V14.2857H17.6429V12.8571ZM16.2143 7.14286H17.6429V8.57143H16.2143V7.14286Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.c4100b29d04ba5c28675cde02ad8fbd2.svg";
export { ForwardRef as ReactComponent };